import { render, staticRenderFns } from "./TltUseRcrdMdl.vue?vue&type=template&id=4dc816e2&"
import script from "./TltUseRcrdMdl.vue?vue&type=script&lang=js&"
export * from "./TltUseRcrdMdl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports